import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

/** Perfect Scrollbar configuration. */
export const PerfectScrollbarConfig: PerfectScrollbarConfigInterface = { suppressScrollX: true };
